module.exports = __webpack_public_path__ + "img/trends-icon-new.b76b3d91.svg";